import {
  GET_PURCHASES_SUCCESS,
  GET_PURCHASES_FAIL,
  GET_PURCHASE_PROFILE_SUCCESS,
  GET_PURCHASE_PROFILE_FAIL,
  ADD_PURCHASE_SUCCESS,
  ADD_PURCHASE_FAIL,
  UPDATE_PURCHASE_SUCCESS,
  UPDATE_PURCHASE_FAIL,
  DELETE_PURCHASE_SUCCESS,
  DELETE_PURCHASE_FAIL,
  DELETE_PURCHASE,
  ADD_NEW_PURCHASE,
  UPDATE_PURCHASE
  
} from "./actionTypes";

const INIT_STATE = {
  data: [],
  purchaseProfile: {},
  error: {},
  loading:false
};

const purchases = (state = INIT_STATE, action) => {
  // console.log(action)
  switch (action.type) {
    case GET_PURCHASES_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total_page: action.payload.total_page
      }

    case GET_PURCHASES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_NEW_PURCHASE:
        return {
          ...state,
          loading:true
        }
    case ADD_PURCHASE_SUCCESS:
      return {
        ...state,
        // purchases: [...state.purchases, action.payload],
        loading:false
      }

    case ADD_PURCHASE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
      case UPDATE_PURCHASE:
        return {
          ...state,
          loading:true
        }
    case UPDATE_PURCHASE_SUCCESS:
      return {
        ...state,
        data: state.data.map(purchase =>
          purchase.id.toString() === action.payload.id.toString()
            ? { ...purchase, ...action.payload }
            : purchase
        ),
        loading:false
      }

    case UPDATE_PURCHASE_FAIL:
      return {
        ...state,
        error: action.payload,
        loading:false
      }
    case DELETE_PURCHASE:
      return {
        ...state,
        loading:true
      }
    case DELETE_PURCHASE_SUCCESS:
      return {
        ...state,
        data: state.data.filter(
          purchase => purchase.id.toString() !== action.payload.id.toString()
        ),
        loading:false
      }

    case DELETE_PURCHASE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_PURCHASE_PROFILE_SUCCESS:
      return {
        ...state,
        purchaseProfile: action.payload,
      }

    case GET_PURCHASE_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
};

export default purchases;
